export const formatPhoneInputValue = (rawValue: string) => {
    const digitsOnly = rawValue.replace(/\D/g, "").slice(0, 10);

    if (digitsOnly.length <= 3) return digitsOnly;
    if (digitsOnly.length <= 6) return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`;
    return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
};

export const formatSubdomainInputValue = (rawValue: string) =>
    rawValue.toLowerCase().replace(/[^a-z-]/g, "");
